import React from 'react';
import { useLocation } from 'react-router-dom';
import { pick } from 'ramda';
import Overlay from 'js/components/common/Overlay';
import { useUpdateEffect } from 'js/hooks/useUpdateEffect';
import { useMyAccountSidebarSelector } from 'js/store/hooks';
import { useCallbackOnLogout } from 'js/hooks/useCallbackOnLogout';

import * as hooks from './hooks';
import { Header } from './components/Header';
import { Content } from './components/Content';

import style from './MyAccountSidebar.scss';

export const MyAccountSidebar = () => {
    const location = useLocation();
    const handleSidebarClose = hooks.useHandleSidebarClose();
    const { isOpened, sidebarPosition } = useMyAccountSidebarSelector(pick(['isOpened', 'sidebarPosition']));
    const isOpenedClass = isOpened ? style.opened : '';

    useUpdateEffect(() => {
        handleSidebarClose();
    }, [location.pathname, handleSidebarClose]);

    useCallbackOnLogout(handleSidebarClose);

    return (
        <>
            <div className={`${style.sidebar} ${isOpenedClass} ${style[sidebarPosition]} cms-my-account-sidebar`}>
                {isOpened && (
                    <>
                        <Header/>
                        <Content/>
                    </>
                )}
            </div>
            {isOpened && (
                <Overlay
                    className={style.overlay}
                    onClick={handleSidebarClose}
                />
            )}
        </>
    );
};
